import { CtaButton } from '@/components/astro/cta-button/cta-button';
import { HeroVoices } from '@/components/astro/new-design-25/Homepage/subcomponents/HeroVoices';

export function SeoHero({
  pageTitle = 'Listen to academic papers on the go',
  pageDescription = 'With voices that sound like an actual person speaking',
}: {
  pageTitle?: string | undefined;
  pageDescription?: string | undefined;
}) {
  return (
    <div
      className='mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8'
      itemScope
      itemType='http://schema.org/WebPageElement'
    >
      <section
        aria-labelledby='hero-heading'
        className='flex flex-col items-center justify-center pt-32 pb-8 text-center sm:pt-40 sm:pb-12 md:pt-48 lg:pt-40 lg:pb-24'
      >
        <h1
          className='mb-4 max-w-xs text-4xl leading-[1.1] font-black sm:mb-6 sm:max-w-2xl sm:text-5xl md:max-w-4xl md:text-6xl lg:text-7xl'
          id='hero-heading'
          itemProp='headline'
        >
          {pageTitle}
        </h1>
        <p
          className='mb-6 max-w-sm text-base font-semibold text-neutral-665 sm:mb-8 sm:max-w-lg sm:text-lg lg:max-w-2xl lg:text-[20px]'
          itemProp='description'
        >
          {pageDescription}
        </p>
        <div aria-label='Get started' className='relative z-10' role='group'>
          <CtaButton
            className='rounded-full bg-royal-50 px-8 py-7 text-xl font-light text-white hover:bg-black/80 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden'
            label='Get Started for Free'
            variant='gradient'
          />
        </div>

        <HeroVoices />
      </section>
    </div>
  );
}
